import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { baseApiSlice } from './slices/baseApiSlice';
import sortingReducer from './slices/sortingSlice'
import profileSettingsReducer from './slices/profileSettingsSlice';

const rootReducer = combineReducers({
  [baseApiSlice.reducerPath]: baseApiSlice.reducer,
  sorting: sortingReducer,
  profileSettings: profileSettingsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApiSlice.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
